import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { authorizationQuery } from "./store/AuthorizationState";
import { setCustomerSettings } from "./CustomerSettings";

let customer;
let userId;
let cycleDate;
let userCustomer;
function Authorization({children}) {
  const authorization = useRecoilValue(authorizationQuery);

  setCustomerSettings(authorization);
  cycleDate = authorization.cycleDate;
  customer = authorization.customerCode;
  userId = authorization.loginUser;
  userCustomer = authorization.userCustomerCode;

  useEffect(() => {
    if(process.env.REACT_APP_GA_MEASUREMENT_ID) {
      //ユーザープロパティを設定する
      window.gtag('set', 'user_properties', {
        'login_id': userId,
        'customer_code': userCustomer
      });
      //ユーザーIDを設定する
      window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
        'user_id': userId
      });
    }
  },[]);

  return (
    children
  );
}

export default Authorization;

export const getCustomer = () => {
  return customer;
}

export const getUserId = () => {
  return userId;
}

export const getCycleDate = () => {
  return cycleDate;
}